import type { ReactNode } from 'react';
import { Text } from '../../../components/general/Text';

interface TelemetryTileProps {
  icon: ReactNode;
  value: string;
  color?: string;
  title?: string;
}

function TelemetryTile({ icon, value, color, title }: TelemetryTileProps) {
  const displayColor = color ?? 'var(--text-primary)';
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        color: displayColor,
        width: '64px'
      }}
      title={title}
    >
      <div style={{ display: 'flex', alignItems: 'center' }}>{icon}</div>
      <Text
        variant='body3-medium'
        style={{
          color: displayColor,
          textAlign: 'left',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          flex: 1
        }}
      >
        {value}
      </Text>
    </div>
  );
}

export default TelemetryTile;
